import { render, staticRenderFns } from "./practiceWorkbook.vue?vue&type=template&id=daee46f8&scoped=true"
import script from "./practiceWorkbook.vue?vue&type=script&lang=js"
export * from "./practiceWorkbook.vue?vue&type=script&lang=js"
import style0 from "./practiceWorkbook.vue?vue&type=style&index=0&id=daee46f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daee46f8",
  null
  
)

export default component.exports